import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
    toggle_visibility_container: {
        cursor: 'pointer'
    }
}));

export {useStyles}